import empty from '@/assets/images/empty.png';
import type { FC, ReactNode } from 'react';

export const Fallback: FC<{ children: ReactNode }> = (props) => {
  // props
  const { children } = props;

  return (
    <section className="flex flex-col gap-1 justify-center items-center h-96">
      <img src={empty} width={200} alt="empty image" />
      {children}
    </section>
  );
};
